import styled, { css } from 'styled-components'

import { getResponsiveFontSizeCSS } from 'helpers/css'

import { NOTIFICATION_POSITIONS, COLOR_MAP } from '.'

const getNotificationPosition = position => {
    switch (position) {
        case NOTIFICATION_POSITIONS.TOP_LEFT:
            return css`
                top: 0;
                left: 0;
            `

        case NOTIFICATION_POSITIONS.TOP_MIDDLE:
            return css`
                top: 0;
                left: 45%;
                transform: translate(-25%, 35%);

                @media only screen and (max-width: 992px) and (orientation: landscape) {
                    top: 8px;
                    left: unset;
                    text-align: center;
                    transform: unset;
                }

                @media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
                    position: absolute;
                    top: 1vh;
                    left: 40%;
                }
            `
        case NOTIFICATION_POSITIONS.TOP_RIGHT:
            return css`
                top: 0;
                right: 0;
            `

        case NOTIFICATION_POSITIONS.BOTTOM_LEFT:
            return css`
                bottom: 0;
                left: 0;
            `

        case NOTIFICATION_POSITIONS.BOTTOM_MIDDLE:
            return css`
                bottom: 0;
                left: 45%;
                transform: translate(-50%, -50%);
            `
        case NOTIFICATION_POSITIONS.BOTTOM_RIGHT:
            return css`
                bottom: 0;
                right: 0;
            `

        default:
            return null
    }
}

export const Wrapper = styled.div`
    font-family: Avenir;
    font-style: normal;
    font-weight: 900;
    font-size: ${getResponsiveFontSizeCSS(20, 26)};
    color: ${props => COLOR_MAP[props.type]};
    position: fixed;
    ${props => getNotificationPosition(props.position)}
    
    ${props =>
        props.kind === 'snackbar' &&
        css`
            position: unset !important;
            color: #fff;
            display: flex;
            flex-grow: 1;
            flex-wrap: wrap;
            font-size: 0.875rem;
            align-items: center;
            font-weight: 400;
            line-height: 1.43;
            border-radius: 0 4px 4px 0;
            letter-spacing: 0.01071em;
            background-color: rgb(50, 50, 50);
            box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
                0px 6px 10px 0px rgba(0, 0, 0, 0.14),
                0px 1px 18px 0px rgba(0, 0, 0, 0.12);
            min-width: 175px;
            max-width: max-content;
            height: 35px;
            justify-content: flex-start;
            padding: 0 5px 0 10px;
            margin: 5px 0;
            border-left: 3px solid ${props => COLOR_MAP[props.type]};
            z-index: 10;
        `}
        ${props =>
            props.hide
                ? css`
                      display: none;
                  `
                : ''}
`
export const Text = styled.p`
    margin: 0;
`
